import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components'
import { LAUNCH } from '../Components/CBtn'
import { connect } from 'react-redux';
import { addFinStruc, changeColoFinStruc, getFs } from '../Actions/Finance_actions';
import ShowFSC from '../Containers/ShowFSC';
import AllPerc from '../Containers/AllPerc';
import { useEffect } from 'react';
import BtnCon from '../APICompoents/BtnCon';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import * as budgIs from '../Assets/JSONS/BugdItems'
import history from '../history.js'
 import NavBar from '../Components/NavBar';


 

const TITLE = styled.h2`
text-align: center;
margin: 0;

`
const NAV = styled.nav`
background: white;
height: fit-content;
margin: 0;

`
const carousel = keyframes`
0% {
    background: url(${require('../Assets/Images/fin.jpg')});
    background-repeat: no-repeat;
    background-size: cover; 
    height: 65vh;

 


}
25% {
    background: url(${require('../Assets/Images/fin2.jpg')});
    background-repeat: no-repeat;
    background-size: cover; 
     height: 65vh;



}
50% {
    background: url(${require('../Assets/Images/fin4.jpg')});
    background-repeat: no-repeat;
    background-size: cover; 
     height: 65vh;



}
75% {
    background: url(${require('../Assets/Images/fin3.jpg')});
    background-repeat: no-repeat;
    background-size: cover; 
     height: 65vh;



}
100% {
    background: url(${require('../Assets/Images/fin5.jpg')});
    background-repeat: no-repeat;
    background-size: cover;
    height: 65vh;
 

}

`
 
const HEAD = styled.header`
@media screen and (min-width: 48rem) {
    margin-top: 10%;
}
 background: url(${require('../Assets/Images/fin.jpg')});
 background-size: cover; 
 background-repeat: no-repeat;
 height: 65vh;
 margin: 0;
 top: 2rem;
 width: 100%;
 position: fixed;
 z-index: -4;
 animation ${carousel} 17s;
 animation-timing-function: ease-in-out;
 animation-iteration-count: 20;
 animation-direction: alternate-reverse;
`
const SECTION = styled.section`
@media screen and (min-width: 48rem) {
    max-width: 50%;
    background: rgba(38, 20, 49, 0.97);
    margin-top: 7%;
    width: fit-content


}
@media screen and (max-width: 48rem) {
max-width: 100%;
background: rgba(38, 20, 49, 0.97);
border-top-left-radius: 3rem;
border-top-right-radius: 3rem;
padding-top: 2.5rem;
margin: 5vh 0 0 0rem;
min-height: 100vh;}

`
const TEXT = styled.input`
padding: 1.2rem;
max-width: 30%;
font-size: medium;
border: none;
outline: none;
`

const ADD = styled( LAUNCH  )`
padding-left: .85rem;
padding-right: .8rem;
margin-left: 1.5rem;
border: none;
outline: none;
border-radius: 1.5rem;
display: inline-block;
    width: 7rem;
    border-radius: .5rem;
    font-size: larger;
&:hover {
    cursor: pointer;
    transform: translateY(.1rem);
    transition: 1.5s ease-in-out;
}
 
`


const LSCREEN = styled.section`
@media screen and (min-width: 48rem) {
display: flex;
flex-flow: column;
align-items: center;
justify-content: center;
border: silver;
 margin: 20vh auto auto auto;
width: 75%;
}
`
const Finance = ({dispatch, Loader, Fs_No}) => {
    const[perc, setPerc] = useState('')
    const[budg, setBudg] = useState('')
    const[comp, setComplete] = useState(true)
    const[i, setI] = useState(true)
    const[show, setShow] = useState(false)
    const[, setDM] = useState(false)
    const[notLoad, setNL] = useState(false)
    const[startGet, setStartGet] = useState(false)
    const[, setEmptyDB] = useState(false)

    const dispaFinSubmit = () => dispatch(addFinStruc({budg, rPerc: Number(Number(perc).toFixed(2))}))

 
    const getCompl = ({num, msg}) => {
        setI(msg)
         
         if(num === 0) {
            setComplete(false) 
            if( i === ' - Item just entered already exists'  ) {
                setComplete(true) 
    
            }
        }  
        else {
            setComplete(true)
        }
    }

    const getErro = msg => {
        if(msg === 'duplicate') {
            setDM(true)
            alert('Your entries seems to already exist, I advise you may go back or make some changes if you intend changing your structure, thanks')
        } else {
            setDM(false)
        }
    }
    useEffect(() => {
        document.title = 'Setup Financial Structure'})
    useEffect(() => {
        if(Fs_No.length < 1) {
             dispatch(getFs())
             setStartGet(true)
        } else {
            setTimeout(() => setShow(true), 1500);
        }
    }, [dispatch, Fs_No])

    useEffect(() => {
        if(startGet) {

              const {isLoading} = Loader[0]  
        
           

              if(!isLoading) {
                  setNL(true)
              } 
              
              if(isLoading === 'no load') {
                 setEmptyDB(true)
                 alert('You seem not to have any Financial structure set up yet, we recommend you do so below, thanks!')
                  setTimeout(() => setShow(true), 1500);

              }
        }
    },[Loader, startGet])

    useEffect(() => {
         if(i === ' - Exceeded limit of 100%' ) {
            dispatch(changeColoFinStruc('red') )
 
        } else if(i === ' - Item just entered already exists') {
             setTimeout(() => dispatch(changeColoFinStruc('red')) , 1100);

        }
    },[i, dispatch])
     
if(!show) {
return (
    <>

    <ArrowBackIcon 
    onClick={history.goBack}
    style={{ fontSize: '40', verticalAlign: 'sub', marginLeft: '.5rem'}}  />
    
        <TITLE style={{marginTop: '3rem'}}>{' What is your financial structure(%) like ? '}</TITLE>
     
            <HEAD style={{backgroundRepeat:'no-repeat'}}>
            <NAV>
    
            </NAV>
            </HEAD>
            <br/>
            <p style={notLoad ? {textAlign:'center', fontSize:'3.5rem', fontWeight:'bold', color:'maroon', marginTop:'25vh'}:{textAlign:'center', fontSize:'4rem', fontWeight:'bold', color:'green', marginTop:'25vh'}}> { notLoad ? 'Error Loading...' : 'Loading your Financial structure, pls wait...' }
            </p>
    </>
)
} 
else {
  
    return ( 
       <>
<NavBar />
<br />
<br />
        {/* {emptyDB ? alert('You seem not to have any Financial structure set up yet, we recommend you do so below, thanks!') : '' } */}
        {/* {emptyDB ? (<AlertMsg msg='You seem not to have any Financial structure set up yet, we recommend you do so below, thanks!' action='FINANCE'  />) : '' } */}
       {/* {dupMsg ? alert('Your entries seems to already exist, I advise you may go back or make some changes if you intend changing your structure, thanks') : '' } */}
       {/* {dupMsg ? <AlertMsg msg='Your entries seems to already exist, I advise you may go back or make some changes if you intend changing your structure, thanks' action='FINANCE'  /> : '' } */}
       <ArrowBackIcon 
    onClick={history.goBack}
    style={{ fontSize: '40', verticalAlign: 'sub', marginLeft: '.5rem'}}  />
    <TITLE style={{marginTop: '3rem'}}>{' What is your financial structure(%) like ? '}</TITLE>
    <br />
<br />
    
       <HEAD style={{backgroundRepeat:'no-repeat'}}>
       <NAV>
    
       </NAV>
       </HEAD>
    <LSCREEN>
    <SECTION>
    
           <AllPerc getNum = {getCompl} />
               <form onSubmit={e => {
               e.preventDefault();
               dispaFinSubmit()
               setBudg('')
               setPerc('')
            
            }}>
               <section style={{marginTop: '2rem',display: 'flex', justifyContent:'space-around'}}>
                   
               <TEXT 
               type='text' 
               placeholder='budget' 
               onChange={({target}) => {setBudg(target.value)}}
               value={budg}
               list='budg'
               required


                />
                
                 <datalist id='budg'>
                 {budgIs['default'].map(s => 
                    <option value={s}></option>
                   )}
               {/* <option value="Feeding"></option>
               <option value="Tithe"></option>
               <option value="Clothing"></option>
               <option value="Family"></option>
               <option value="School"></option> */}
                
               </datalist> 
               
               <TEXT 
               type={'number'} 
               placeholder='percent' 
               onChange={ ({target}) => { setPerc(target.value)} }
               value={perc}
                 required
    
               />
    
                   
           </section>
           
           <ADD onClick={() => {
            //    dispatch(addFinStruc({budg, rPerc: Number(Number(perc).toFixed(2))}))
            //    setBudg('')
            //    setPerc('')
       }
           
           } disabled={!comp} style={{display:` ${ comp ? 'inline' : 'none'}` }}>Add +</ADD>
               </form>
               <span style={{display:` ${ comp ? 'none' : 'inline'}` }}>
    {/* 
    <ADD onClick={() => { postFS({budg: budg, perc: perc})
    history.push('/wall/arm@gmail.com')
    }}> Continue </ADD> */}
    <BtnCon getErro = {getErro} />
    
    </span>
                
    
    
        <ShowFSC />
      
    
       </SECTION>
       
    
    </LSCREEN>
    
    
       </>
    );
}
     
 
}
 
const mapStateToProps = ({Indicate, Fs}) => {
    return {
        Loader: Indicate,
        Fs_No: Fs,
    }
}
 
export default connect(mapStateToProps, null)(Finance);